import { converObjectToBlob } from 'utils';
import { SAMLRequestType, OIDCRequestType } from './constant';

export const getOrderPayload = ({ order, uploadedFiles = [] }) => {
    let applicationTypeValue = '';
    if (order?.requestType === SAMLRequestType) {
        applicationTypeValue = 'Web application';
    } else if (order?.requestType === OIDCRequestType) {
        applicationTypeValue = order?.appType;
    }

    const payload = {
        requestedType: order?.requestType,
        businessApplication: order?.businessApplication,
        applicationCI: order?.applicationCI,
        sector: order?.sector,
        environment: order?.environment === 'Pre-Production' ? 'Pre-Prod' : order?.environment,
        oktaAppId: order?.appClientId,
        clientName: order?.appClientName,
        dataClasification: order?.dataClassification,
        ...{ applicationType: applicationTypeValue },
        applicationName: order?.applicationName?.trim(),
        applicationURL: order?.applicationUrl,
        applicationOwner: order?.appOwnerDetails?.gpid,
        ...(order?.requestType === SAMLRequestType && {
            acsURL: order?.acsURL,
            entityId: order?.audienceURI,
            nameIdFormat: order?.nameIdFormat,
            applicationUserName: order?.applicationUserName,
            destinationURL: order?.destinationUrl,
            recipientURL: order?.recipientUrl,
        }),
        ...(order?.requestType === OIDCRequestType &&
            order?.loginUrl && {
                loginURL: order?.loginUrl.filter((url) => url && url.trim() !== ''),
            }),
        ...(order?.requestType === OIDCRequestType &&
            order?.logoutUrl && {
                logoutURL: order?.logoutUrl.filter((url) => url && url.trim() !== ''),
            }),
        ...(order?.disclaimerAcknowledged && {
            disclaimerAcknowledged: order?.disclaimerAcknowledged,
        }),

        applicationLogoRequired: order?.applicationLogoRequired === 'yes',
        ...(order?.logoHref && { logoHref: order?.logoHref }),
    };

    const newPayload = {
        ...payload,
        ...(order?.orderId && {
            deletedFiles: order?.deletedFiles || [],
        }),
    };
    const formData = new FormData();
    const blobPayload = converObjectToBlob(newPayload);
    formData.append('ssoRequest', blobPayload);
    if (uploadedFiles && uploadedFiles?.length) {
        uploadedFiles?.forEach((file) => {
            // Only append if file is a File or Blob (not plain object)
            if (file instanceof File || file instanceof Blob) {
                if (!order?.orderId) {
                    formData.append('file', file);
                }
                if (!file?.blobRelativeLink && order?.orderId) {
                    formData.append('file', file);
                }
            }
        });
    } else {
        formData.append('file', null);
    }
    if (uploadedFiles && uploadedFiles?.length && uploadedFiles?.every((file) => file?.blobRelativeLink)) {
        formData.append('file', new Blob([''], { type: 'application/octet-stream' }), '');
    }
    return formData;
};

export const formUploadObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;

    return (
        catalogConfig?.filesUploadResponse?.uploadResponses?.map((item) => ({
            id: item?.id,
            name: item?.fileName,
            blobRelativeLink: item?.blobRelativeLink,
            size: item?.fileSize || 0,
            href: item?.href,
        })) || []
    );
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;

    return {
        requestType: catalogConfig?.requestedType,
        businessApplication: catalogConfig?.businessApplication,
        applicationCI: catalogConfig?.applicationCI,
        businessApplicationDetails: {
            label: catalogConfig?.businessApplication,
            value: catalogConfig?.businessApplication,
        },
        sector: catalogConfig?.sector,
        environment: catalogConfig?.environment === 'Pre-Prod' ? 'Pre-Production' : catalogConfig?.environment,
        appClientId: catalogConfig?.oktaAppId,
        appClientIdDetails: catalogConfig?.oktaAppId ? { label: catalogConfig?.oktaAppId, value: catalogConfig?.oktaAppId } : null,
        appClientName: catalogConfig?.applicationName,
        dataClassification: catalogConfig?.dataClasification,
        ...{
            appType: catalogConfig?.applicationType,
        },
        ...(catalogConfig?.requestedType === SAMLRequestType && {
            nameIdFormat: catalogConfig?.nameIdFormat,
            applicationUserName: catalogConfig?.applicationUserName,
        }),
        applicationName: catalogConfig?.applicationName,
        applicationUrl: catalogConfig?.applicationURL,
        appOwner: null,
        appOwnerDetails: { name: data?.manager?.name, gpid: data?.manager?.id },
        appOwnerText: catalogConfig?.applicationOwner,
        ...(catalogConfig?.requestedType === SAMLRequestType && {
            acsURL: catalogConfig?.acsURL,
            audienceURI: catalogConfig?.entityId,
            destinationUrl: catalogConfig?.acsURL,
            recipientUrl: catalogConfig?.acsURL,
        }),
        ...(catalogConfig?.requestedType === OIDCRequestType &&
            catalogConfig?.loginURL && {
                loginUrl: catalogConfig?.loginURL,
            }),
        ...(catalogConfig?.requestedType === OIDCRequestType &&
            catalogConfig?.logoutURL && {
                logoutUrl: catalogConfig?.logoutURL,
            }),
        applicationLogoRequired: catalogConfig?.applicationLogoRequired ? 'yes' : 'no',
        ...(catalogConfig?.logoHref && { logoHref: catalogConfig?.logoHref }),
        isTouched: false,
    };
};

export const getSsoResubmitRequestPayload = ({ order }) => {
    const catalog = order?.catalogServices?.[0]?.catalogConfig;

    const payload = {
        requestedType: catalog?.requestedType,
        businessApplication: order?.businessApplication,
        applicationCI: order?.applicationCI,
        sector: catalog?.sector,
        environment: catalog?.environment === 'Pre-Production' ? 'Pre-Prod' : catalog?.environment,
        oktaAppId: catalog?.oktaAppId,
        clientName: catalog?.clientName,
        dataClasification: catalog?.dataClasification,
        ...{ applicationType: catalog?.applicationType },
        applicationName: catalog?.applicationName?.trim(),
        applicationURL: catalog?.applicationURL,
        applicationOwner: catalog?.applicationOwner,
        ...(catalog?.requestedType === SAMLRequestType && {
            acsURL: catalog?.acsURL,
            entityId: catalog?.entityId,
            nameIdFormat: catalog?.nameIdFormat,
            applicationUserName: catalog?.applicationUserName,
            destinationURL: catalog?.acsURL,
            recipientURL: catalog?.acsURL,
        }),
        ...(catalog?.requestedType === OIDCRequestType &&
            catalog?.loginURL && {
                loginUrl: catalog?.logoutURL,
            }),
        ...(catalog?.requestedType === OIDCRequestType &&
            catalog?.logoutURL && {
                logoutUrl: catalog?.logoutURL,
            }),

        applicationLogoRequired: catalog?.applicationLogoRequired ? 'yes' : 'no',
        ...(catalog?.logoHref && { logoHref: catalog?.logoHref }),
    };
    const newPaylod = { ...payload, deletedFiles: [], newFiles: [] };
    return newPaylod;
};

export const formAppClientIdOrderObjDetails = (data = null) => {
    if (!data) return {};
    return {
        ...(data?.oktaAppId && { appClientId: data?.oktaAppId || null }),
        ...(data?.oktaAppId && { appClientIdDetails: { label: data?.oktaAppId, value: data?.oktaAppId, appClientId: data?.oktaAppId, data } }),
        ...(data?.applicationName && { applicationName: data?.applicationName, isAppNamePrepopulated: true }),
        ...(data?.applicationURL && { applicationUrl: data?.applicationURL, isAppUrlPrepopulated: true }),
        ...(data?.acsURL && {
            acsURL: data?.acsURL,
            isAcsUrlPrepopulated: true,
            recipientUrl: data?.acsURL,
            destinationUrl: data?.acsURL,
        }),
        ...(data?.applicationType && { appType: data?.applicationType, isAppTypePrepopulated: true }),
        ...(data?.entityId && { audienceURI: data?.entityId, isAudienceUriPrepopulated: true }),
        ...(data?.nameIdFormat && { nameIdFormat: data?.nameIdFormat, isNameIdFormatPrepopulated: true }),
        ...(data?.applicationUserName && { applicationUserName: data?.applicationUserName }),
        applicationLogoRequired: data?.isApplicationLogoAvailable ? 'yes' : 'no',
        ...(data?.loginUrl && { loginUrl: data?.loginUrl }),
        ...(data?.logoutUrl && { logoutUrl: data?.logoutUrl }),
        isTouched: false,
        deletedFiles: [],
    };
};
export const resetOrder = {
    catalogCode: null,
    applicationCI: null,
    sector: null,
    environment: null,
    envShortName: null,
    businessApplication: null,
    businessApplicationDetails: null,
    appType: null,
    dataClassification: null,
    applicationName: null,
    applicationUrl: null,
    loginUrl: [],
    logoutUrl: [],
    appShortName: null,
    appOwner: null,
    appOwnerDetails: null,
    requestType: null,
    acsURL: null,
    appOwnerText: null,
    audienceURI: null,
    isTouched: false,
    nameIdFormat: null,
    destinationUrl: null,
    recipientUrl: null,
    applicationUserName: null,
    accessRestrictions: [],
    appClientId: null,
    appClientIdDetails: null,
    appClientName: null,
    applicationLogoRequired: 'no',
    logoHref: null,
    disclaimerAcknowledged: false,
    deletedFiles: [],
};

export const commonRegex =
    /^(https?:\/\/)(?!.*(?:secure\.pepsico|secure\.mypepsico|secure\.ite\.pepsico|secure\.ite\.mypepsico|secure\.it\.pepsico|secure\.it\.mypepsico|okta|oktapreview|oktadebugger|oidcdebugger|localhost))([a-zA-Z0-9\-_:/.?=]+)$/i;

export const urlConfig = {
    common: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
    production: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
    applicationURL: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
};

export const validateLoginLogoutURL = (url, environment, requestType) => {
    let config;

    if (requestType === OIDCRequestType) {
        config = urlConfig?.common;
    } else if (requestType === SAMLRequestType && environment?.toLowerCase() === 'production') {
        config = urlConfig?.production;
    } else {
        config = urlConfig?.applicationURL;
    }

    if (!config) {
        throw new Error(`Invalid environment: ${environment}`);
    }

    const isValid = url !== null && url !== '' ? config.regex.test(url) : true;

    return {
        isValid,
        message: isValid ? 'Valid URL' : config.message,
    };
};
export const audienceURIRegX =
    /^(?!.*\b(?:secure\.pepsico|secure\.mypepsico|secure\.ite\.pepsico|secure\.ite\.mypepsico|secure\.it\.pepsico|secure\.it\.mypepsico|okta|oktadebugger|oktapreview|localhost|oidcdebugger)\b)([^\s"<>]+(:\d+)?(\/[^\s"<>]*)?$|^com[:/.].*)$/i;

export const validateShortDesc = ({ order }) => {
    const formatRegex = /^[\s\S]{4,1000}$/;
    const isValid = formatRegex.test(order?.shortDescription);
    return {
        isValid,
        message: isValid ? 'Valid' : 'Short Description is invalid.',
    };
};
